<template>
    <div class="na-form">
        <div v-if="roundDetail" class="left">
            <DxTabPanel>
                <DxItem :title="tx.TabBaseData">
                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouId }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='roundDetail.RouId' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='roundDetail.RouName' />
                            </div>
                            <!--<div class="udc-description">
                                <div class="udc-field-required">*</div>
                                <div class="udc-field-description"></div>
                            </div>-->
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouBegin }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='roundDetail.RouBegin' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouEnd_1 }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='roundDetail.RouEnd_1' />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouEnabled }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='roundDetail.RouEnabled' />
                            </div>
                        </div>


                        <div class="dx-field">
                            <div class="dx-field-label">Bild:</div>
                            <div class="dx-field-value">
                                <DxFileUploader accept="image/jpg"
                                                :multiple="false"
                                                upload-mode="instantly"
                                                @value-changed="onUploadingImage" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label"></div>
                            <div class="dx-field-value">
                                <img :src="rouImage" class="dx-image" />
                            </div>
                        </div>



                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouChangedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='roundDetail.RouChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouChangedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='roundDetail.RouChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouCreatedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='roundDetail.RouCreatedOn' :readOnly="true" />
                            </div>

                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.RouCreatedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='roundDetail.RouCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="tx.TabSuchfelder">
                    <DxDataGrid :data-source="roundSuchfeldList"
                                key-expr="LitId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="LitName" :caption="col.Suchfeld" data-type="string" :allowEditing="false" />
                        <DxColumn data-field="Selected" :caption="col.Selected" data-type="boolean" :width="120" />
                    </DxDataGrid>

                </DxItem>
                <DxItem :title="tx.TabGroups">
                    <DxDataGrid :data-source="roundGroupList"
                                key-expr="GrpId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="GrpName" :caption="col.GrpName" data-type="string" :allowEditing="false" />
                        <DxColumn data-field="Allowed" :caption="col.RgrAllowed" data-type="boolean" :width="120" />
                    </DxDataGrid>

                </DxItem>
                <DxItem :title="tx.TabTopicTypes">
                    <DxDataGrid :data-source="roundTopicTypeList"
                                key-expr="TtyId"
                                :remote-operations="false"
                                :allow-column-reordering="true"
                                :row-alternation-enabled="true"
                                :show-borders="true">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   select-text-on-edit-start="true"
                                   start-edit-action="click"
                                   mode="cell" />
                        <DxColumn data-field="TtyName" :caption="col.TtyName" data-type="string" :allowEditing="false" />
                        <DxColumn data-field="TtrName" :caption="col.TtrName" data-type="string" cssClass="csEditable" :allowEditing="true" />
                        <DxColumn data-field="Allowed" :caption="col.TtrAllowed" data-type="boolean" :width="120" />
                    </DxDataGrid>

                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              :text="btn.Save"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick($event)" />
                </div>
                <div>
                    <DxButton :width="120"
                              :text="btn.Delete"
                              type="danger"
                              styling-mode="contained"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              :text="btn.Back"
                              type="back"
                              styling-mode="contained"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxTextBox/*, DxTextArea*/ } from 'devextreme-vue'
    import { DxButton } from 'devextreme-vue/button'
    import { DxTabPanel } from 'devextreme-vue/tab-panel'
    import { DxDataGrid, DxColumn, DxEditing } from 'devextreme-vue/data-grid'
    import { DxItem } from 'devextreme-vue/html-editor'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxDateBox } from 'devextreme-vue/date-box'
    import { confirm } from "devextreme/ui/dialog"
    import { DxFileUploader } from 'devextreme-vue/file-uploader'
    import $ from 'jquery'
    export default {
        name: 'RoundDetail',
        components: {

            DxButton, DxTabPanel, DxItem,
            DxTextBox, DxDataGrid, DxColumn, DxEditing,
            DxDateBox, DxCheckBox, DxFileUploader

        },
        data() {
            return {
                tx: {
                    TabBaseData: this.$LanguageProvider.GetResource("TabBaseData", "Caption", "Basisdaten"),
                    TabSuchfelder: this.$LanguageProvider.GetResource("TabSuchfelder", "Caption", "Suchfelder"),
                    TabGroups: this.$LanguageProvider.GetResource("TabGroups", "Caption", "Rollen"),
                    TabTopicTypes: this.$LanguageProvider.GetResource("TabTopicTypes", "Caption", "Thementypen"),
                    RouId: this.$LanguageProvider.GetResource("RouId", "Caption", "ID"),
                    RouName: this.$LanguageProvider.GetResource("RouName", "Caption", "Name"),
                    RouBegin: this.$LanguageProvider.GetResource("RouBegin", "Caption", "Beginn der Kampagne"),
                    RouEnd_1: this.$LanguageProvider.GetResource("RouEnd_1", "Caption", "Ende der Kampagne"),
                    RouEnabled: this.$LanguageProvider.GetResource("RouEnabled", "Caption", "Aktiviert"),
                    RouChangedOn: this.$LanguageProvider.GetResource("RouChangedOn", "Caption", "Geändert am"),
                    RouChangedBy: this.$LanguageProvider.GetResource("RouChangedBy", "Caption", "Geändert von"),
                    RouCreatedOn: this.$LanguageProvider.GetResource("RouCreatedOn", "Caption", "Erstellt am"),
                    RouCreatedBy: this.$LanguageProvider.GetResource("RouCreatedBy", "Caption", "Erstellt von")
                },
                col: {
                    Selected: this.$LanguageProvider.GetResource("Selected", "Column", "Ausgewählt"),
                    Suchfeld: this.$LanguageProvider.GetResource("Suchfeld", "Caption", "Suchfeld"),
                    RgrAllowed: this.$LanguageProvider.GetResource("RgrAllowed", "Column", "Sichtbar"),
                    TtrAllowed: this.$LanguageProvider.GetResource("TtrAllowed", "Column", "Sichtbar"),
                    TtrName: this.$LanguageProvider.GetResource("TtrName", "Caption", "Thementyp"),
                    TtyName: this.$LanguageProvider.GetResource("TtyName", "Caption", "Alias"),
                    GrpName: this.$LanguageProvider.GetResource("GrpName", "Caption", "Rolle"),
                },
                btn: {
                    Save: this.$LanguageProvider.GetResource("Save", "Button", "Speichern"),
                    Delete: this.$LanguageProvider.GetResource("Delete", "Button", "Löschen"),
                    Back: this.$LanguageProvider.GetResource("Back", "Button", "Zurück"),
                }
            };
        },
        computed: {
            lang() {
                return this.$LanguageProvider
            },
            roundDetail() {
                return this.$store.state.roundStore.roundDetail
            },
            roundDetailText() {
                return JSON.stringify(this.$store.state.roundStore.roundDetail)
            },
            roundSuchfeldList() {
                return this.$store.state.roundStore.roundSuchfeldList
            },
            roundSuchfeldListText() {
                return JSON.stringify(this.$store.state.roundStore.roundSuchfeldList)
            },
            roundGroupList() {
                return this.$store.state.roundStore.roundGroupList
            },
            roundGroupListText() {
                return JSON.stringify(this.$store.state.roundStore.roundGroupList)
            },
            roundTopicTypeList() {
                return this.$store.state.roundStore.roundTopicTypeList
            },
            roundTopicTypeListText() {
                return JSON.stringify(this.$store.state.roundStore.roundTopicTypeList)
            },
            saveButtonType() {
                return this.$store.state.roundStore.roundDetailChanged
                    || this.$store.state.roundStore.roundSuchfeldListChanged
                    || this.$store.state.roundStore.roundGroupListChanged
                    || this.$store.state.roundStore.roundTopicTypeListChanged
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.$store.state.roundStore.roundDetailChanged
                    || this.$store.state.roundStore.roundSuchfeldListChanged
                    || this.$store.state.roundStore.roundTopicTypeListChanged
                    || this.$store.state.roundStore.roundGroupListChanged
                    ? false : true
            },
            rouImage() {
                return this.$store.state.roundStore.rouImage
            },
        },
        props: {
            rouId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            roundDetailText: function (newVal, oldVal) {
                if (oldVal != "{}") {
                    this.$store.state.roundStore.roundDetailChanged = true
                }
            },
            roundSuchfeldListText: function (newVal, oldVal) {
                if (oldVal != "[]") {
                    this.$store.state.roundStore.roundSuchfeldListChanged = true
                }
            },
            roundGroupListText: function (newVal, oldVal) {
                if (oldVal != "[]") {
                    this.$store.state.roundStore.roundGroupListChanged = true
                }
            },
            roundTopicTypeListText: function (newVal, oldVal) {
                if (oldVal != "[]") {
                    this.$store.state.roundStore.roundTopicTypeListChanged = true
                }
            }
        },
        mounted: function () {
            let vm = this
            this.$store.dispatch("getRoundDetail", { rouId: vm.rouId })
            this.$store.dispatch("getRoundSuchfeldList", { rouId: vm.rouId })
            this.$store.dispatch("getRoundGroupList", { rouId: vm.rouId })
            this.$store.dispatch("getRoundTopicTypeList", { rouId: vm.rouId })
        },
        methods: {
            onCancelClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.$store.dispatch("saveRoundDetail")
                this.$store.dispatch("saveRoundSuchfeldList")
                this.$store.dispatch("saveRoundGroupList")
                this.$store.dispatch("saveRoundTopicTypeList")
            },
            onDeleteClick() {
                let result = confirm("Sind Sie sicher, dass Sie die Kampagne löschen möchten? Ein Löschen ist nicht möglich, wenn bereits verknüpfte Datensätze bestehen", "Löschen bestätigen");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.$store.dispatch("deleteRoundDetail")
                    }
                });
            },
            onUploadingImage(e) {
                let reader = new FileReader()
                if (e.value && e.value.length > 0) {
                    reader.readAsDataURL(e.value[0])
                    reader.onload = function () {
                        this.self.roundDetail.RouImageUri = this.reader.result
                        this.self.$store.state.roundStore.rouImage = this.reader.result
                        this.self.$store.state.roundStore.roundDetailChanged = true
                        this.component.reset()
                    }.bind({ reader, self: this, component: e.component });
                }
            }
        }
    }


</script>
<style>
</style>
